module.exports = __webpack_public_path__ + "img/dashboardin.abe70cd2.svg";